import React, { ReactElement } from 'react'
import { useTranslation } from 'react-i18next'

import { Text as TextComponent } from '../../../Typography'

interface FileErrorProps {
  fileName?: string
  errorMessage?: string
  withMargin?: boolean
}

export const FileError = ({ fileName, errorMessage }: FileErrorProps): ReactElement | null => {
  const { t } = useTranslation()

  if (!fileName || !errorMessage) {
    return null
  }

  const errorText = `${fileName || t('error')} - ${errorMessage}`

  return <TextComponent colorVariant="danger">{errorText}</TextComponent>
}
